import React, { useState, useEffect } from 'react'
import { Modal } from '../../ui'
import { Icon } from '@iconify/react'
import { Button } from '../../ui/legacy'

const DatePickerInput = React.forwardRef(
  ({ label, name, required, error, onChange, value }, ref) => {
    const [isOpen, setIsOpen] = useState(false)
    const [selectedDate, setSelectedDate] = useState(null)
    const isRequiredError = error?.message === 'Hãy chọn ngày tháng năm'
    const errorClass = 'border-red-500'

    useEffect(() => {
      if (value) {
        const parsedDate = parseDate(value)
        setSelectedDate(parsedDate)
        setCurrentDate(parsedDate)
      }
    }, [value])

    const parseDate = (dateString) => {
      const [day, month, year] = dateString.split('/').map(Number)
      return new Date(year, month - 1, day)
    }

    const formatDate = (date) => {
      if (!date) return ''
      return date.toLocaleDateString('vi-VN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
    }

    const getDaysInMonth = (year, month) =>
      new Date(year, month + 1, 0).getDate()
    const getFirstDayOfMonth = (year, month) => {
      let day = new Date(year, month, 1).getDay()
      return day === 0 ? 6 : day - 1 // Adjust for Monday as the first day
    }

    const generateCalendarDays = (currentDate) => {
      const year = currentDate.getFullYear()
      const month = currentDate.getMonth()
      const daysInMonth = getDaysInMonth(year, month)
      const firstDay = getFirstDayOfMonth(year, month)
      const days = []

      for (let i = 0; i < firstDay; i++) {
        days.push(null)
      }
      for (let i = 1; i <= daysInMonth; i++) {
        days.push(i)
      }

      while (days.length < 42) {
        days.push(null)
      }
      return days
    }

    const [currentDate, setCurrentDate] = useState(new Date())

    const handlePrevMonth = () => {
      setCurrentDate(
        new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
      )
    }

    const handleNextMonth = () => {
      setCurrentDate(
        new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
      )
    }

    const handleDateClick = (day) => {
      if (day) {
        const newSelectedDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          day
        )
        setSelectedDate(newSelectedDate)
      }
    }

    const handleSubmit = () => {
      onChange(formatDate(selectedDate))
      setIsOpen(false)
    }

    const handleCancel = () => {
      setSelectedDate(null)
      setIsOpen(false)
    }

    return (
      <section>
        <label className="mb-1 text-sm font-bold text-black">
          {label} {required && <span className="text-red-accent">*</span>}
        </label>
        <div className="relative">
          <div
            className={`focus:shadow-outline flex min-h-[2.8rem] w-full cursor-pointer appearance-none items-center rounded-md border border-gray-400 px-4 py-3 leading-tight text-gray-700 shadow focus:outline-none ${
              error && errorClass
            }`}
            onClick={() => setIsOpen(!isOpen)}
          >
            {formatDate(selectedDate)}
          </div>
        </div>
        {/* <p className="mt-1 h-1 text-sm text-red-accent">
          {!isRequiredError && error ? error?.message : ''}
        </p> */}

        {isOpen && (
          <Modal
            onClose={handleCancel}
            className="w-[37vw] overflow-y-auto rounded-lg bg-white p-4"
          >
            <div className="mb-4 flex items-center justify-between">
              <button onClick={handlePrevMonth} className="px-1">
                <Icon icon="ph:caret-left" className="global-icon mx-auto" />
              </button>
              <h1 className="text-2xl font-extrabold">
                {currentDate.toLocaleString('default', {
                  month: 'long',
                  year: 'numeric',
                })}
              </h1>
              <button onClick={handleNextMonth} className="px-1">
                <Icon icon="ph:caret-right" className="global-icon mx-auto" />
              </button>
            </div>
            <div className="grid grid-cols-7 gap-x-8">
              {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day) => (
                <div
                  key={day}
                  className="text-center font-semibold text-gray-accent"
                >
                  {day}
                </div>
              ))}
              {generateCalendarDays(currentDate).map((day, index) => (
                <button
                  key={index}
                  onClick={() => handleDateClick(day)}
                  className={`py-1 text-center ${
                    day
                      ? 'rounded-full hover:bg-gray-200'
                      : 'cursor-default text-gray-400'
                  } ${
                    selectedDate &&
                    selectedDate.getDate() === day &&
                    selectedDate.getMonth() === currentDate.getMonth() &&
                    selectedDate.getFullYear() === currentDate.getFullYear()
                      ? 'rounded-full bg-gray-secondary text-white'
                      : ''
                  }`}
                  disabled={!day}
                >
                  {day}
                </button>
              ))}
            </div>

            <div className="flex justify-end">
              <Button
                variant={'tertiary'}
                onClickHandler={handleCancel}
                className="px-2 py-2"
              >
                Hủy
              </Button>
              <Button variant={'primary'} onClickHandler={handleSubmit}>
                Xác nhận
              </Button>
            </div>
          </Modal>
        )}
      </section>
    )
  }
)

export default DatePickerInput
